// /signup — real Clerk <SignUp /> surface for the marketing/docs link.
//
// The previous version of this route redirected /signup -> /signin on the
// assumption that Clerk's <SignIn /> shows a built-in "Sign up" tab. It
// does, but only when <SignIn /> owns the URL — when the link points at
// a separate /signup route, redirecting it back to /signin makes the
// "Sign up" click look like a no-op. This page renders the actual
// <SignUp /> widget so the click is observable.
//
// routing="hash" — Clerk's <SignUp /> multi-step flow (verify-email-address,
// continue, sso-callback, …) navigates to sub-paths in path-routing mode,
// which TanStack Router can't match without a catch-all per step. Hash
// routing keeps the URL at /signup and moves the step into the URL
// fragment (/signup#verify-email-address), so the same route handles every
// step. Documented default for @clerk/clerk-react.
import { SignUp } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/signup")({
  component: SignupRoute,
});

function SignupRoute() {
  return (
    <div
      className="flex min-h-svh items-center justify-center px-4 py-8"
      data-testid="signup-clerk-wrap"
    >
      <SignUp routing="hash" signInUrl="/signin" forceRedirectUrl="/" />
    </div>
  );
}
